// extracted by mini-css-extract-plugin
export default {"effectspiechartscreen-titles":"EffectsPieChartScreen_effectspiechartscreen-titles__e-ilI","effectspiechartscreen-chart":"EffectsPieChartScreen_effectspiechartscreen-chart__mohsK"};